import Vue from 'vue/dist/vue.min.js';
import { lory } from 'lory.js';

const testimonial = () => {

    let testimonialItem = document.querySelectorAll('.testimonial');

    let testimonialConstructor = (id) => {
        Vue.component('testimonial', {
            data: function() {
                return {
                    sliderEl: null,
                    options: {
                        classNameFrame: 'testimonial__frame',
                        enableMouseEvents: true
                    },
                    lory: null,
                    currentSlide: 1,
                    length: null
                }
            },
            computed: {
               
            },
            watch: {
                
            },
            methods: {
                initLory() {
                    this.lory = lory(this.sliderEl, this.options);
                },
                initListener() {
                    this.sliderEl.addEventListener('after.lory.slide', () => {
                        this.currentSlide = this.lory.returnIndex() + 1;
                    });
                },
                nextSlide() {
                    this.lory.next();
                },
                prevSlide() {
                    this.lory.prev();
                }
            },
            mounted() {
                this.sliderEl = this.$el.querySelector('.testimonial__slider');
                this.length = this.$el.querySelectorAll('.testimonial__slide').length;
                this.initLory();
                this.initListener();
            }
        });

        new Vue({
            el: `.testimonial-${id}`,
        }).$mount(`.testimonial-${id}`, true);
    }

    if (testimonialItem.length > 0) {
        testimonialItem.forEach((item, index) => {
            item.classList.add(`testimonial-${index}`);
            testimonialConstructor(index);
        })
    }

}

export default testimonial;